export default __webpack_public_path__ + "static/media/LANCER-LIRICAL.eac85152.png";